// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"759":"1a336c86","984":"3e5ce5a3"}[chunkId] + ".chunk.js";
};